<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yiL9KS/tc-custom/9783988268716.jpg?1704425416107" alt="This image is the cover for the book Be Young Again!, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Be Young Again!, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Be Young Again! is a science fiction short story written by Murray Leinster, an American author known for his significant contributions to the science fiction genre during the 20th century. "Be Young Again!" likely explores a speculative or futuristic scenario where advancements in science or technology provide the means for individuals to regain their youth or reverse the aging process. The story might introduce a protagonist who, through a scientific breakthrough or an innovative procedure, has the opportunity to become young again.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Murray Leinster
      </h2>
      
      <p class="authorDescription body article">Murray Leinster was the pen name of William Fitzgerald Jenkins (June 16, 1896 – June 8, 1975), an American science fiction and alternate history writer. He was a prolific author with a career spanning several decades, during which he made significant contributions to the science fiction genre.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?74b4399c